export const menuList = [
  {
    name: "Dashboard",
    icon: "dashboard",
  },
  {
    name: "Franchisee Details",
    icon: "business",
  },
  {
    name: "Payment Reports",
    icon: "payment",
  },
  {
    name: "Banners",
    icon: "image",
  },
 
  {
    name: "Franchisee Edit Requests",
    icon: "edit",
  },
  {
    name: "Register Customers",
    icon: "person",
  },
 
  // {
  //   name: "Holiday Mark",
  //   icon: "note",
  // },
  {
    name: "Alerts",
    icon: "message",
  },
  {
    name: "Other Services",
    icon: "work",
  },
  // {
  //   name:"Feedbacks",
  //   icon:"feedback",
  // },

];
